/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CreateVersionResponse,
  CreateVersionResponse$inboundSchema,
  CreateVersionResponse$Outbound,
  CreateVersionResponse$outboundSchema,
} from "./createversionresponse.js";

export type ListVersionsResponse = {
  /**
   * Object type
   */
  object: "list";
  /**
   * Array of version objects
   */
  data: Array<CreateVersionResponse>;
};

/** @internal */
export const ListVersionsResponse$inboundSchema: z.ZodType<
  ListVersionsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  object: z.literal("list"),
  data: z.array(CreateVersionResponse$inboundSchema),
});
/** @internal */
export type ListVersionsResponse$Outbound = {
  object: "list";
  data: Array<CreateVersionResponse$Outbound>;
};

/** @internal */
export const ListVersionsResponse$outboundSchema: z.ZodType<
  ListVersionsResponse$Outbound,
  z.ZodTypeDef,
  ListVersionsResponse
> = z.object({
  object: z.literal("list"),
  data: z.array(CreateVersionResponse$outboundSchema),
});

export function listVersionsResponseToJSON(
  listVersionsResponse: ListVersionsResponse,
): string {
  return JSON.stringify(
    ListVersionsResponse$outboundSchema.parse(listVersionsResponse),
  );
}
export function listVersionsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListVersionsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListVersionsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListVersionsResponse' from JSON`,
  );
}
